import gql from 'graphql-tag'

export interface GQLGetContentQueryInput {
  id: string
}

export const GET_CONTENT = gql`
  query getContent($id: ID!) {
    getContent(id: $id) {
      body
      css
      id
      js
    }
  }
`

export interface GQLGetContentByTitleQueryInput {
  title: string
}

export const GET_CONTENT_BY_TITLE = gql`
  query getContentByTitle($title: String!) {
    getContentByTitle(title: $title) {
      body
      css
      id
      js
    }
  }
`
